import { useTranslate } from '@tolgee/react';
import { useMemo } from 'react';

interface Props {
  isTokoMigrate2TT?: boolean;
}

function AuthInvalid(props: Props) {
  const { isTokoMigrate2TT } = props;
  const { t } = useTranslate();

  const text = useMemo(() => {
    if (isTokoMigrate2TT) {
      return t('scene.chatWorkspace.currentConversation.error.storeMigratedToTiktok');
    }
    return t('scene.chatWorkspace.conversationList.error.storeSync');
  }, [isTokoMigrate2TT, t]);

  return (
    <div className="w-full px-[8px] py-[10px] flex items-center justify-between leading-[20px] bg-[#ffe492]">
      {text}
    </div>
  );
}

export default AuthInvalid;
